import PostsCard from "./PostsCard";

export default PostsCard;
